import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody } from '@chakra-ui/react'
import React from 'react'
import { ReservationProvider, useReservation } from './ReservationContext'
import ReservationCreateConfirm from './ReservationCreateConfirm'
import ReservationCreateDate from './ReservationCreateDate'
import ReservationCreatePassword from './ReservationCreatePassword'
import ReservationCreateRoomTime from './ReservationCreateRoomTime'
import ReservationCreateTitle from './ReservationCreateTitle'

// モーダル用のラッパーコンポーネント
type CustomModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({ isOpen, onClose, title, children }) => (
    <Modal isOpen={isOpen} onClose={onClose} size="md" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody pb={6}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );

const ReservationCreateContent: React.FC = () => {
  const { step, goBack } = useReservation()

  const renderMainContent = () => {
    // 新規予約のタブが選択されている場合、予約作成の適切なステップを表示
    switch (step) {
      case 'room-date':
        return <ReservationCreateDate />
      case 'room-time':
        return <ReservationCreateRoomTime />
      default:
        return null
    }
  }

  const renderModal = () => {
    switch (step) {
      case 'title':
        return (
          <CustomModal isOpen onClose={goBack} title="">
            <ReservationCreateTitle />
          </CustomModal>
        )
      case 'password':
        return (
          <CustomModal isOpen onClose={goBack} title="">
            <ReservationCreatePassword />
          </CustomModal>
        )
      case 'confirm':
        return (
          <CustomModal isOpen onClose={goBack} title="">
            <ReservationCreateConfirm />
          </CustomModal>
        )
      default:
        return null
    }
  }

  return (
    <Box>
      {renderMainContent()}
      {renderModal()}
    </Box>
  )
}

const ReservationCreate: React.FC = () => (
  <ReservationProvider>
    <ReservationCreateContent />
  </ReservationProvider>
)

export default ReservationCreate 